<script lang="ts">
  import type {
    MlbGameDataResponse,
    MlbPlayByPlayResponse,
    MlbStatKey,
  } from '@statmuse/core/gamera/index'
  import * as store from './stores'
  import { onMount } from 'svelte'

  export let gameData: MlbGameDataResponse<MlbStatKey>
  export let playByPlay: MlbPlayByPlayResponse

  onMount(() => {
    store.init({ gameData, playByPlay })
    return () => store.gameState.set({})
  })
</script>
